import ScaleBar from './scale-bar';
export default ScaleBar;
